import React from 'react';

interface SBMobileBannerProps {
    appName?: string;
    downloadUrl?: string;
    onClose?: () => void;
    visible?: boolean;
}

const SBMobileBanner: React.FC<SBMobileBannerProps> = ({ 
    appName = "DDSJobs", 
    downloadUrl = "#", 
    onClose,
    visible = true 
}) => {
    if (!visible) return null;

    return (
        <div className="sb-mobile-banner">
            <div className="banner-content">
                <i className="fa fa-mobile"></i>
                <span>Get the {appName} mobile app</span>
                <a href={downloadUrl} className="download-link">
                    Download
                </a>
                {onClose && (
                    <button 
                        className="close-banner" 
                        onClick={onClose}
                        type="button"
                    >
                        <i className="fa fa-times"></i>
                    </button>
                )}
            </div>
        </div>
    );
};

export default SBMobileBanner;
